import { createFileRoute } from "@tanstack/react-router";
import { CertificationProgressClaimsPage } from "../../../components/system/CertificationProgressClaimsPage";
import { requireSuperAdmin } from "../../../lib/auth/route-protection";

export const Route = createFileRoute("/system/certifications/claims")({
  beforeLoad: requireSuperAdmin(),
  component: CertificationProgressClaimsPage,
});
